import { ResourceProps } from 'react-admin';
import { Shield as PermissionIcon } from '@mui/icons-material';

const PermissionResource: ResourceProps = {
  name: 'permissions',
  icon: PermissionIcon,
};

export default PermissionResource;
